<div
  class="grid grid-cols-[auto_1fr_auto] text-white dark px-6 py-2 bg-neutral-900 rounded-lg vertical-center"
>
  <div class="grid grid-cols-[auto_1fr_auto] gap-1">
    <div class="content-center text-neutral-300 text-xs">Context:</div>

    <div class="content-center text-white text-xs">
      {{ selectedDocument()?.filename || 'No document selected' }}
    </div>
  </div>

  @if (newDocumentsCount() > 0) {
    <div class="flex items-center gap-1 justify-self-end px-4">
      <i class="ph-fill ph-circle text-yellow-500 text-[7px]"></i>
      <span class="text-yellow-500 text-xs"
        >{{ newDocumentsCount() }} new
        {{ newDocumentsCount() === 1 ? 'document' : 'documents' }} uploaded</span
      >
    </div>
  }

  @if (selectedProcessResourceId()) {
    <button
      [disabled]="isLoading()"
      (click)="openContextDocuments()"
      class="flx-ds ternary w-fit justify-self-end small context-button"
      flxButton
      variant="ternary"
    >
      Change Context
    </button>
  }
</div>
